import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment, environment as env } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { RxStompService } from './app/rx-stomp.service';
import { rxStompServiceFactory } from './app/rx-stomp-service-factory';
import { OrganisationService } from './app/organisation.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AppComponent } from './app/app.component';
import { projectHeaderInterceptor } from './app/pages/fmeda/services/project-header.interceptor';
if (environment.production) {
    enableProdMode();
}

const pdfWorkerSrc = new URL('assets/pdfjs/pdf.worker.min.mjs', document.baseURI).toString();
const workerWindow = window as Window & {
    pdfWorkerSrc?: string;
    'pdfWorkerSrc4.8.69'?: string;
};
workerWindow.pdfWorkerSrc = pdfWorkerSrc;
workerWindow['pdfWorkerSrc4.8.69'] = pdfWorkerSrc;

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(BrowserModule, AppRoutingModule, NgbModule, FormsModule, ReactiveFormsModule, MatExpansionModule, MatButtonModule, MatDialogModule, MatTableModule, MatPaginatorModule, MatProgressBarModule, MatSortModule, MatInputModule, MatFormFieldModule, AuthModule.forRoot({
            ...env.auth,
            httpInterceptor: {
                ...env.httpInterceptor,
            },
        })),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },
        {
            provide: Window,
            useValue: window,
        },
        {
            provide: RxStompService,
            useFactory: rxStompServiceFactory,
        },
        {
            provide: OrganisationService,
            useFactory: () => new OrganisationService(),
        },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([projectHeaderInterceptor]))
    ]
})
    .catch(err => console.error(err));
